<div class="toast-container position-fixed top-0 end-0 p-3">
  @for (toast of toastService.toasts; track toast) {
    <ngb-toast
      #ngbToast="ngbToast"
      class="ch-toast"
      [class.ch-toast-info]="toast.type === 'info'"
      [class.ch-toast-warning]="toast.type === 'warning'"
      [class.ch-toast-dismissible]="toast.options.tapToDismiss"
      [autohide]="isTimerRunning(toast)"
      [delay]="toast.options.timeout"
      (hidden)="toastService.close(toast)"
      (mouseenter)="hovered.add(toast)"
      (mouseleave)="pointerLeft(toast)"
      (click)="dismiss(toast, ngbToast)">
      <div class="d-flex align-items-start">
        <i
          class="fas fa-lg me-3 mt-2"
          [class.fa-info-circle]="toast.type === 'info'"
          [class.fa-exclamation-triangle]="toast.type === 'warning'"
          aria-hidden="true"></i>
        <div class="flex-grow-1 ch-toast-text">
          @if (toast.title) {
            <div class="fw-bold">{{ toast.title }}</div>
          }
          @if (toast.message.length > 0) {
            <div>
              @for (part of toast.message; track $index) {
                @if (part.bold) {
                  <b>{{ part.text }}</b>
                } @else {
                  <ng-container>{{ part.text }}</ng-container>
                }
              }
            </div>
          }
          @for (link of toast.options.links; track link) {
            <div>
              <button type="button" class="btn btn-link p-0" (click)="action(toast, link.text, $event)">
                @if (link.icon) {
                  <i [class]="link.icon"></i>
                }
                {{ link.text }}
              </button>
            </div>
          }
        </div>
        @if (toast.options.closeButton) {
          <button
            type="button"
            class="btn-close flex-shrink-0 ms-2"
            aria-label="Close"
            (click)="$event.stopPropagation(); ngbToast.hide()"></button>
        }
      </div>

      @if (toast.options.buttons.length > 0) {
        <div class="d-flex justify-content-end flex-wrap gap-2 mt-2">
          @for (button of toast.options.buttons; track button) {
            <button
              type="button"
              class="btn btn-sm"
              [ngClass]="button.class || 'btn-secondary'"
              (click)="action(toast, button.text, $event)">
              @if (button.icon) {
                <i [class]="button.icon"></i>
              }
              {{ button.text }}
            </button>
          }
        </div>
      }

      <!-- restarts with the timer, because it's created again when the timer starts again -->
      @if (toast.options.progressBar && isTimerRunning(toast)) {
        <div class="ch-toast-progress" [style.animation-duration.ms]="toast.options.timeout"></div>
      }
    </ngb-toast>
  }
</div>
